<template>
  <div class="">

  </div>
</template>

<script>
  export default {
    created() {
      this.apiGet({
        brokerId : this.$route.params.brokerId
      }, 'broker/detail', (broker) => {
          this.$router.push({
            name  : 'broker-stripe', 
            params: {
              brokerId : broker.id
            }
          })
      })
    },
  }
</script>